import Tdg_OrganisationEventModelBase from '../_generated/modelBases/tdg-organisation-event-model-base';

export default class Tdg_OrganisationEventModel extends Tdg_OrganisationEventModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
